export default __webpack_public_path__ + "static/media/photo--lg--66.380859a7.jpg";